import { render, staticRenderFns } from "./Fund.vue?vue&type=template&id=5fbb9058&scoped=true"
import script from "./Fund.vue?vue&type=script&lang=js"
export * from "./Fund.vue?vue&type=script&lang=js"
import style0 from "./Fund.vue?vue&type=style&index=0&id=5fbb9058&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbb9058",
  null
  
)

export default component.exports